import actionCreatorFactory from "typescript-fsa";
import { bindThunkAction } from "typescript-fsa-redux-thunk";

import { RootState } from "../../state";
import { UnknownError } from "../../common/actions/VisitApi";
import { isFailure } from "../../common/actions/VisitApi";
import { requestToCreateSupport, CreateSupportParams } from "../api";

const actionCreator = actionCreatorFactory("PROJECT_SUPPORTS");

export type CreateSupportActionParams = CreateSupportParams;
export const createSupport = actionCreator.async<RootState, CreateSupportActionParams, null, UnknownError>("CREATED");
export const createSupportWorker = bindThunkAction(createSupport, async (params, dispatch) => {
  const req = requestToCreateSupport(params);
  const res = await dispatch(req);
  if (isFailure(res)) {
    throw res.payload.body;
  }
  if (process.env.NODE_ENV === "production") {
    (window as any).ga("send", "event", "support", "success", params.projectId);
  }
  return null;
});



// WEBPACK FOOTER //
// ./frontend/src/project_supports/actions/index.ts